<template>
  <div class="punctuate-rule-detail">
    <div class="rule-type">
      <el-radio-group v-model="rType" @change="handleRuleTypeChange" disabled>
        <el-radio :label="1">{{$t('newProjectV2.byParagraphBreak')}}</el-radio>
        <el-radio :label="0">{{$t('newProjectV2.bySentBreak')}}</el-radio>
        <el-radio :label="2">{{$t('newProjectV2.customRule')}}</el-radio>
      </el-radio-group>
    </div>
    <div class="rule-header" v-show="rType === 2">
      <el-button type="primary" @click="handleCreateRule">{{$t('newProjectV2.createRule')}}</el-button>
      <el-button class="download" @click="handleDownload">{{$t('newProjectV2.downloadTemplate')}}</el-button>
    </div>
    <div class="rule-table" v-show="rType === 2">
      <el-table
        :data="punctuateRuleList"
        height="100%"
        ref="multipleTable"
        tooltip-effect="dark"
        header-row-class-name="customHeader"
        border
      >
        <el-table-column :label="$t('newProjectV2.serialNumber')" align="center" width="55">
          <template slot-scope="{ $index }">
            {{$index + 1}}
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('newProjectV2.enable')"
          align="center"
          width="70"
        >
          <template slot-scope="{ row }">
            <el-radio disabled v-model="ruleID" @change="radioChange(row.id)" :label="row.id"><span></span></el-radio>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('newProjectV2.name')"
          align="center"
          prop="ruleName"
          :show-overflow-tooltip='true'
        ></el-table-column>
        <el-table-column
          :label="$t('newProjectV2.language')"
          align="center"
          :show-overflow-tooltip='true'
        >
          <template slot-scope="{ row }">
            {{ $i18n.locale === 'zh' ? row.langName : $langCase[row.langCode] }}
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('newProjectV2.operate')"
          align="center"
          class-name="operate"
        >
          <template slot-scope="{ row }">
            <el-tooltip effect="dark" :content="$t('newProjectV2.edit')" placement="top">
              <i class="icon-edit" @click="handleEdit(row)"></i>
            </el-tooltip>
            <el-tooltip effect="dark" v-if="row.type === 0" :content="$t('newProjectV2.config')" placement="top">
              <i class="icon-setting" @click="handleConfig(row)"></i>
            </el-tooltip>
            <el-tooltip effect="dark" :content="$t('newProjectV2.del')" placement="top">
              <i class="icon-delete" @click="handleDelete(row.id)"></i>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <DelDialog
      width="480px"
      :dialogVisible="delVisible"
      @handleClose="deleteCancel"
      @handleConfirm="handleDel"
    >
      {{$t('newProjectV2.delTip')}}
    </DelDialog>

    <CreateRule
      :visible="createVisible"
      @handleCancel="createCancel"
      @updateRule="getPunctuateRule"
    ></CreateRule>

    <EditRule
      :editRule="editRule"
      :visible="editVisible"
      @handleCancel="editCancel"
      @updateRule="getPunctuateRule"
    ></EditRule>

    <ConfigRule
      :editRule="editRule"
      :configVisible="configVisible"
      @handleCancelConfig="handleCancelConfig"
      @updateRule="getPunctuateRule"
    ></ConfigRule>
  </div>
</template>

<script>
import DelDialog from '@/components/delDialog';
import CreateRule from '@/components/projectDialog/createRule';
import EditRule from '@/components/projectDialog/editRule';
import ConfigRule from '@/components/projectDialog/configRule';

import { apiRoot } from '@/services/ajax';
import { deletePunctuateRule } from '@/services/dialogApi';
import { queryAllPunctuateRule } from '@/services/newProjectApi';

export default {
  name: 'PunctuateRuleDetail',
  props: {
    segmentRuleId: {
      type: Number,
      default () {
        return 0;
      }
    },
    createInfo: {
      type: Object,
      default () {
        return {};
      }
    },
    ruleType: {
      type: Number,
      default () {
        return 2;
      }
    },
  },
  components: {
    DelDialog,
    CreateRule,
    EditRule,
    ConfigRule,
  },
  data () {
    return {
      punctuateRuleList: [],
      ruleID: this.segmentRuleId,
      delVisible: false,

      configVisible: false,
      editRule: {},

      editVisible: false,
      createVisible: false,
      rType: this.ruleType,
    }
  },
  mounted () {
    this.getPunctuateRule();
  },
  methods: {
    handleRuleTypeChange (type) {
      this.$emit('ruleTypeChange', type);
    },
    async getPunctuateRule () {
      let { result, success } = await queryAllPunctuateRule({
        sourceLang: this.createInfo.sourceLang,
      });
      if (success) {
        this.punctuateRuleList = result;
      }
    },
    handleCreateRule () {
      this.createVisible = true;
    },
    createCancel () {
      this.createVisible = false;
    },
    handleDownload () {
      let link = document.createElement("a");
      link.style.display = "none";
      link.href = apiRoot('/transSegmentRule/downloadTemplate');
      document.body.appendChild(link);
      link.click();
    },
    radioChange () {
      this.$emit('updateRuleID', this.ruleID);
    },
    handleEdit (row) {
      this.editRule = { ...row };
      this.editVisible = true;
    },
    editCancel () {
      this.editVisible = false;
    },
    handleCancelConfig () {
      this.configVisible = false;
    },
    handleConfig (row) {
      this.editRule = { ...row };
      this.configVisible = true;
    },
    async handleDel () {
      this.delVisible = false;
      let { success } = await deletePunctuateRule({
        guideProgress: 0,
        id: this.selDelID,
      });
      if (!success) { return }
      this.$message({
        type: 'success',
        message: this.$t('newProjectV2.delSuccess')
      });
      this.getPunctuateRule();
    },
    handleDelete (id) {
      this.selDelID = id;
      this.delVisible = true;
    },
    deleteCancel () {
      this.delVisible = false;
    },
  }
}
</script>

<style lang="less" scoped>
  @import "./assets/style.less";
</style>